import { splitGrapheme } from "../../../lib/wordGenerator/splitGrapheme";
import { DictionaryMatchFilter } from "../../../param/generalSearchFilter";
import { GeneralSearchInput } from "../../../param/generalSearchInput";
import { filter, convertFlat } from "../commonLoop";
import { createDictionaryTable, createSortedTable } from "../table/dictionaryTable";
import { Result } from "../generalSearchResult";

export const dictionaryMatchFilter = async ({
  query,
  input,
  words,
  result,
  workerContext,
}: {
  query: DictionaryMatchFilter;
  input: GeneralSearchInput;
  words: string[];
  result: Result;
  workerContext: any;
}) => {
  if (!query.anagramMatch) {
    const dictKey =
      query.dictionary ||
      (input.inputDictionary !== "free" ? input.inputDictionary : "");
    if (!dictKey) {
      return [];
    }
    const dictKeyArr = Array.isArray(dictKey) ? dictKey : [dictKey];
    const dict = createDictionaryTable(dictKeyArr);
    if (!dict) {
      return [];
    }

    return await filter(workerContext, result, (e) => {
      return (
        (query.notMatch && !dict[e.currentWord]) ||
        (!query.notMatch && !!dict[e.currentWord])
      );
    });
  } else {
    // anagram match
    // アナグラムして辞書にある単語に変換します。
    const dictKey =
      query.dictionary ||
      (input.inputDictionary !== "free" ? input.inputDictionary : "");
    if (!dictKey) {
      return [];
    }
    const dictKeyArr = Array.isArray(dictKey) ? dictKey : [dictKey];
    const dict = createSortedTable(dictKeyArr);
    if (!dict) {
      return [];
    }

    return await convertFlat(workerContext, result, (e) => {
      const key = splitGrapheme(e.currentWord).sort().join("");
      if (!query.notMatch) {
        const ret = (dict[key] ?? []).map((e2) => {
          const newe = JSON.parse(JSON.stringify(e));
          newe.currentWord = e2;
          return newe;
        });
        return ret;
      } else {
        return dict[key]?.length ? [] : [e];
      }
    });
  }
};
